import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { Tile } from 'components/Layout/PageContainer';
import { TbIllustration } from 'components/Figma';

export function NoOpportunitiesFound() {
  const intl = useIntl();

  return (
    <Tile className="flex flex-row w-full items-center justify-center mx-auto py-1 h-[200px]">
      <TbIllustration name="Congratulations" className="mr-6" size="sm" />
      <div className="flex flex-col text-left">
        <Typography style={{ fontSize: 16, fontWeight: 800 }}>
          {intl.formatMessage({ id: 'benchmarking.error.expansion_opportunities.title' })}
        </Typography>
        <Typography style={{ fontSize: 16, fontWeight: 300 }}>
          {intl.formatMessage({ id: 'benchmarking.error.expansion_opportunities.description' })}
        </Typography>
      </div>
    </Tile>
  );
}
